module.exports = __webpack_public_path__ + "static/media/82.951de17d.jpg";